import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-question-rating",
  "use": "foquz-icon-question-rating-usage",
  "viewBox": "0 0 25 20",
  "content": "<symbol viewBox=\"0 0 25 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-question-rating\"><path d=\"M7 7.2L9 6v8m9.5-12.599A2.999 2.999 0 0120 4v12a3 3 0 01-1.5 2.599m4-17.198A2.999 2.999 0 0124 4v12a3 3 0 01-1.5 2.599M4 19h9a3 3 0 003-3V4a3 3 0 00-3-3H4a3 3 0 00-3 3v12a3 3 0 003 3z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol